import { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import './Dropdown.css'

export default function Dropdown({ toggleContent, items, className = "" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const toggle = () => setOpen((prev) => !prev);
  const close = () => setOpen(false);

  // Close dropdown when clicking outside or pressing Escape
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        close();
      }
    }
    function handleKeyDown(event) {
      if (event.key === "Escape") close();
    }
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className={`dropdown ${className}`} ref={ref}>
      <button
        type="button"
        className="dropdown__toggle"
        onClick={toggle}
        aria-expanded={open}
        aria-haspopup="menu"
      >
        {toggleContent}
      </button>

      {open && (
        <div className="dropdown__menu" role="menu">
          <div className="dropdown__inner">
            <ul className="dropdown__list">
              {items.map(
                (
                  { label, iconBefore, iconAfter, onClick, to, danger, isTextOnly },
                  idx
                ) => (
                  <li key={idx} className="dropdown__item" role="none">
                    {isTextOnly ? (
                      <div
                        className="dropdown__link dropdown__link--text"
                        role="menuitem"
                      >
                        {iconBefore && (
                          <span className="dropdown__icon dropdown__icon--before">
                            {iconBefore}
                          </span>
                        )}
                        {label}
                        {iconAfter && (
                          <span className="dropdown__icon dropdown__icon--after">
                            {iconAfter}
                          </span>
                        )}
                      </div>
                    ) : to ? (
                      <NavLink
                        to={to}
                        className={`dropdown__link ${
                          danger ? "dropdown__link--danger" : ""
                        }`}
                        onClick={close}
                        role="menuitem"
                      >
                        {iconBefore && (
                          <span className="dropdown__icon dropdown__icon--before">
                            {iconBefore}
                          </span>
                        )}
                        {label}
                        {iconAfter && (
                          <span className="dropdown__icon dropdown__icon--after">
                            {iconAfter}
                          </span>
                        )}
                      </NavLink>
                    ) : (
                      <button
                        type="button"
                        className={`dropdown__link ${
                          danger ? "dropdown__link--danger" : ""
                        }`}
                        onClick={() => {
                          onClick?.();
                          close();
                        }}
                        role="menuitem"
                      >
                        {iconBefore && (
                          <span className="dropdown__icon dropdown__icon--before">
                            {iconBefore}
                          </span>
                        )}
                        {label}
                        {iconAfter && (
                          <span className="dropdown__icon dropdown__icon--after">
                            {iconAfter}
                          </span>
                        )}
                      </button>
                    )}
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}
